export default "__VITE_ASSET__BUe5wLvs__"